/**
 * Centralized route-to-documentation mapping for CMP Portal.
 *
 * This file is the single source of truth for in-app help links.
 * Every route should have a corresponding documentation entry.
 */

import type { DocsLinkConfig, HelpLinkEntry } from '@digiwedge/ui-docs-link';

/**
 * Route-to-documentation mapping.
 *
 * Routes are matched in order; first match wins.
 * Use '/*' suffix for wildcard matching.
 */
export const HELP_LINKS: HelpLinkEntry[] = [
  // Sites
  {
    route: '/sites',
    docPath: '/portal/sites',
    label: 'Sites Management',
  },
  {
    route: '/sites/*',
    docPath: '/portal/sites',
    label: 'Site Details',
  },

  // Analytics
  {
    route: '/analytics',
    docPath: '/portal/analytics',
    label: 'Analytics Dashboard',
  },
  {
    route: '/analytics/*',
    docPath: '/portal/analytics',
    label: 'Analytics Details',
  },

  // Overrides
  {
    route: '/overrides',
    docPath: '/portal/overrides',
    label: 'Consent Overrides',
  },
  {
    route: '/overrides/*',
    docPath: '/portal/overrides',
    label: 'Override Details',
  },

  // Scans
  {
    route: '/scans',
    docPath: '/portal/scans',
    label: 'Cookie Scans',
  },
  {
    route: '/scans/*',
    docPath: '/portal/scans',
    label: 'Scan Results',
  },

  // Exports
  {
    route: '/export',
    docPath: '/portal/exports',
    label: 'Data Exports',
  },
  {
    route: '/export/*',
    docPath: '/portal/exports',
    label: 'Export Details',
  },

  // Config Editor
  {
    route: '/config',
    docPath: '/portal/config-editor',
    label: 'Config Editor',
  },
  {
    route: '/config/*',
    docPath: '/portal/config-editor',
    label: 'Configuration',
  },

  // Themes (admin)
  {
    route: '/admin/themes',
    docPath: '/portal/themes',
    label: 'Theme Editor',
    adminOnly: true,
  },
  {
    route: '/admin/themes/*',
    docPath: '/portal/themes',
    label: 'Theme Details',
    adminOnly: true,
  },

  // Diagnostics
  {
    route: '/diagnostics',
    docPath: '/portal/diagnostics',
    label: 'Diagnostics',
  },

  // Health
  {
    route: '/health',
    docPath: '/portal/health',
    label: 'Health Status',
  },

  // Default fallback - Portal overview
  {
    route: '/',
    docPath: '/portal/overview',
    label: 'Portal Overview',
  },
];

export const DOCS_CONFIG: DocsLinkConfig = {
  baseUrl: 'https://cmp-docs.digiwedge.com',
  envUrlKey: 'VITE_DOCS_BASE_URL',
  windowUrlKey: '__CMP_DOCS_URL__',
  helpLinks: HELP_LINKS,
};
